import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import TextField from "@material-ui/core/TextField";
import SweetAlert from "sweetalert2-react";
import fire from "../config/Fire";

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class AgregaFotos extends React.Component {
  constructor(props) {
    super(props);
    this.handleUploadAR = this.handleUploadAR.bind(this);
    this.cambiosInputs = this.cambiosInputs.bind(this);
  }
  state = {
    open: false,
    titulo: "",
    imagen: null,
    uploadValue: 0,
    titulo1: null
  };
  //Permite abrir el dialogo
  handleClickOpen = () => {
    this.setState({
      open: true
    });
  };
  //Permite cerrar el dialogo
  handleClose = () => {
    this.setState({
      open: false,
      titulo: "",
      location: "",
      imagen: null,
      uploadValue: 0
    });
    this.setState({
      show: true,
      estado: "error",
      texto: "El album no ha sido creado",
      titulo1: "Error"
    });
  };
  //Guarda lo que escribe el usuario en los inputs
  cambiosInputs(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  //Crea el post
  subirPost = () => {
    if (this.state.uploadValue === 100) {
      this.satisfactorio();
    } else {
      this.setTimeout();
    }
  };

  satisfactorio = () => {
    this.setState({
      open: false,
      titulo: "",
      imagen: null,
      uploadValue: 0
    });
    this.setState({
      show: true,
      estado: "success",
      texto: "El album ha sido creado",
      titulo1: "¡Enhorabuena!"
    });
  };
  setTimeout = () => {
    setTimeout(this.subirPost, 3000);
  };

  handleNew = () => {
    if (this.state.titulo !== "") {
      if (this.state.location !== "") {
        var f = new Date();
        var fecha =
          f.getDate() + "-" + (f.getMonth() + 1) + "-" + f.getFullYear();
        var tit = this.state.titulo + " " + fecha + "-" + this.state.location;
        this.setState({ titulo: tit });
        this.subirImagen(tit);
        this.subirPost(tit);
      } else alert("Debes ingresar una ciudad para el album");
    } else {
      alert("Debes ingresar un título para el album");
    }
  };
  //Sube la imagen a firebase
  subirImagen(titulo) {
    if (this.state.imagen !== null) {
      this.state.imagen.map(key => {
        const storageRef = fire.storage().ref(`/Album/${titulo}/${key.name}`);
        const task = storageRef.put(key);
        task.on(
          "state_changed",
          snapshot => {
            let percentage =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            this.setState({
              uploadValue: percentage
            });
          },
          error => {},
          () => {
            storageRef.getDownloadURL().then(url => {
              fire
                .database()
                .ref()
                .child("Album")
                .child(titulo)
                .push()
                .set({ name: key.name, link: url });
            });
          }
        );
      });
    } else {
      alert("Se deben ingresar imágenes al album");
    }
  }
  //Guarda información de la imagen
  handleUploadAR(event) {
    const files_array = Array.from(event.target.files);
    this.setState({ imagen: files_array });
  }
  //Renderiza la interfaz del diálogo
  render() {
    return (
      <div>
        <div>
          <Button
            variant="outlined"
            color="primary"
            onClick={this.handleClickOpen}
          >
            Nuevo album de fotos
          </Button>
          <Dialog
            open={this.state.open}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">
              {"Nuevo album de fotos"}
            </DialogTitle>
            <DialogContent>
              <TextField
                id="outlined-full-width"
                label="Título"
                fullWidth
                margin="normal"
                variant="outlined"
                name="titulo"
                onChange={this.cambiosInputs}
                value={this.state.titulo}
                InputLabelProps={{
                  shrink: true
                }}
              />
              <TextField
                id="outlined-full-width"
                label="Ciudad"
                fullWidth
                margin="normal"
                variant="outlined"
                name="location"
                onChange={this.cambiosInputs}
                value={this.state.location}
                InputLabelProps={{
                  shrink: true
                }}
              />
              <div>
                <progress value={this.state.uploadValue} max="100" />
                <br />
                <input
                  accept="image/*"
                  multiple
                  type="file"
                  disableUnderline={true}
                  name="Imagen"
                  onChange={this.handleUploadAR}
                />
                <br />
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Cancelar
              </Button>
              <Button onClick={this.handleNew} color="primary">
                Agregar imagen
              </Button>
            </DialogActions>
          </Dialog>
        </div>

        <div>
          <SweetAlert
            show={this.state.show}
            title={this.state.titulo1}
            type={this.state.estado}
            text={this.state.texto}
            onConfirm={() => this.setState({ show: false })}
          />
        </div>
      </div>
    );
  }
}

export default AgregaFotos;
